var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgThunderUnlimited = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00b719",
    stroke: "#3fc551",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 9.5,
    height: 9.5,
    rx: 4.75,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.779,2.053h-.805L24.093.532a.315.315,0,0,0,.019-.351A.385.385,0,0,0,23.779,0H21.89a.386.386,0,0,0-.328.172l-1.511,2.4a.314.314,0,0,0,0,.341.386.386,0,0,0,.327.17h1.238l-1.188,1.88a.322.322,0,0,0,.1.442.408.408,0,0,0,.5-.03l3.023-2.737a.319.319,0,0,0,.082-.373A.381.381,0,0,0,23.779,2.053Z",
    transform: "translate(-17.079 2.262)",
    fill: "#fff"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThunderUnlimited, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thunderUnlimited.8489970b.svg";
export { ForwardRef as ReactComponent };